import type { ExperimentConfig } from '../@types'

// i3.1 — WTP axis driven by traffic source (UA channel) instead of currency (GT-4496).
// female + female-water-fasting share the plan-f base paywall and the fasting WTP rule, so both
// point at the same transform. male shares the fasting rule but a different base (plan-m).
// activity-female-walking uses the walking WTP rule and its own base (plan-walking-f).
const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&ml_price=premium&country=US&area=female&exp=web_ml_price_prediction_wtp_traffic_source_i3_1~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_wtp_traffic_source_i3_1/f'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&ml_price=premium&country=US&area=female-water-fasting&exp=web_ml_price_prediction_wtp_traffic_source_i3_1~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_wtp_traffic_source_i3_1/f'),
			},
		},
		male: {
			// /result_complete?safe&mock-data&ml_price=premium&country=US&area=male&exp=web_ml_price_prediction_wtp_traffic_source_i3_1~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_wtp_traffic_source_i3_1/m'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&ml_price=premium&country=US&area=activity-female-walking&exp=web_ml_price_prediction_wtp_traffic_source_i3_1~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_wtp_traffic_source_i3_1/walking_f'),
			},
		},
	},
]

export default config
